<template>
    <div>
        <!-- DIALOGO CONFIRMAR ELIMINACION -->
        <Dialog :visible.sync="deleteProductDialog" :styles="{ width: '450px' }" header="Confirmar" :modal="true">
            <div class="confirmation-content">
                <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
                <span>Estas seguro de eliminar <b>{{ editedUsuario.nombre }}</b>.?</span>
            </div>
            <template #footer>
                <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteProductDialog = false" />
                <Button label="Si" icon="pi pi-check" class="p-button-text" @click="eliminarUsuario()" />
            </template>
        </Dialog>
        <!-- DIALOGO PARA ERRORES -->
        <div class="p-d-flex">
            <Toast />
        </div>
        <!-- NUEVO USUARIO -->
        <Dialog :showHeader="false" :visible.sync="dialogoUsuario" header=" " :containerStyle="{ width: '1800px' }"
            :closeOnEscape="true" :closable="true">
            <Usuarios @closeUsuario="cerrarVentanaUsuario()"></Usuarios>
        </Dialog>
        <!-- DIALOGO DE LOADING -->
        <Dialog :visible.sync="loading" :closable="false" :containerStyle="{ width: '300px' }">
            <ProgressBar mode="indeterminate" style="height: .5em" />
            <span>{{ loadingMensaje }}</span>
        </Dialog>
        <Card>
            <template #title>
                <div class="text-left p-d-flex justify-center p-fluid grid formgrid">
                    <div class="mt-0 ml-0 mr-0 mb-0 pt-0 pl-3 pr-0 pb-0 pa-0 justify-right field col-6 md:col-6">
                        Usuarios Internos
                    </div>
                    <div class="mt-0 ml-0 mr-0 mb-0 pt-0 pl-0 pr-5 pb-0 pa-0 text-right justify-right field col-6 md:col-6">
                        <Button @click="nuevoUsuario()" icon="pi pi-plus" class="mr-2 p-button-rounded" />
                        <Button @click="getUsuarios()" icon="pi pi-undo" class="p-button-rounded" />
                    </div>
                </div>
            </template>
            <template #content>
                <DataTable class="p-datatable-sm" :filters.sync="filtrosUsuario" removableSort showGridlines ref="alamcenes"
                    :value="itemUsuarios" responsiveLayout="scroll"
                    :globalFilterFields="['nombre', 'usuario', 'rfc', 'curp', 'puesto', 'departamento', 'almacen.descripcion']"
                    :paginator="true" :rows="10"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Usuarios"
                    :loading="loadingItemsUsuarios">
                    <template #header>
                        <div class="flex justify-content-between">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filtrosUsuario['global'].value" placeholder="Buscar" />
                            </span>
                        </div>
                    </template>
                    <Column sortable field="nombre" header="Nombre"
                        :bodyStyle="{ 'text-align': 'left', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.nombre }}
                        </template>
                    </Column>
                    <Column sortable field="usuario" header="Usuario"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.usuario }}
                        </template>
                    </Column>
                    <Column sortable field="rfc" header="RFC" :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.rfc }}
                        </template>
                    </Column>
                    <Column sortable field="curp" header="CURP"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.curp }}
                        </template>
                    </Column>
                    <Column sortable field="puesto" header="Puesto"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.puesto }}
                        </template>
                    </Column>
                    <Column sortable field="departamento" header="Departamento"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.departamento }}
                        </template>
                    </Column>
                    <Column sortable field="almacen.descripcion" header="Almacén"
                        :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }">
                        <template #body="{ data }">
                            {{ data.almacen.descripcion }}
                        </template>
                    </Column>
                    <Column :bodyStyle="{ 'text-align': 'center', overflow: 'visible' }" header="Acciones"
                        :exportable="false" :styles="{ 'min-width': '8rem' }">
                        <template #body="slotProps">
                            <Button icon="pi pi-pencil" style="width:35px; height:35px"
                                class="p-button-rounded p-button-success mr-2" @click="editarUsuario(slotProps.data)"
                                v-tooltip.bottom="'Editar'" />
                            <Button icon="pi pi-trash" style="width:35px; height:35px"
                                class="p-button-rounded p-button-danger" @click="confirmDeleteProduct(slotProps.data)"
                                v-tooltip.bottom="'Eliminar'" />
                        </template>
                    </Column>
                </DataTable>
            </template>
        </Card>
    </div>
</template>
<script>
import axios from 'axios'
import { FilterMatchMode, FilterOperator } from 'primevue/api/';
import Usuarios from './Usuarios.vue';

export default {
    data() {
        return {
            loadingMensaje: "",
            loading: false,
            filtrosUsuario: {
                "global": { value: null, matchMode: FilterMatchMode.CONTAINS },
                "nombre": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "usuario": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "curp": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "rfc": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "puesto": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "departamento": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
                "almacen.descripcion": { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            },
            dialogoUsuario: false,
            deleteProductDialog: false,
            loadingItemsUsuarios: false,
            editedIndexUsuario: -1,
            editedUsuario: {}
        };
    },
    computed: {
        itemUsuarios() {
            return this.$store.state.listaUsuariosInternosStore
        },
        usuario() {
            return this.$store.state.usuarioInternosStore;
        },
        empresa() {
            return this.$store.state.usuario;
        },
    },
    created() {
        this.getUsuarios();
    },
    methods: {
        nuevoUsuario() {
            this.dialogoUsuario = true
            if (this.$store.state.usuarioInternosStore != 0) {
                let objetoUsuario = {
                    idUsuario: 0,
                    rfc: '',
                    curp: '',
                    nombre: '',
                    usuario: '',
                    pin: '',
                    puesto: '',
                    departamento: '',
                    serie: '',
                    permisos: [],
                    telefonos: [],
                    correos: [],
                    foto: {
                        base64: '',
                    },
                    almacen: {},
                }
                this.$store.state.usuarioInternosStore = { ...objetoUsuario }
            }
        },
        cerrarVentanaUsuario() {
            this.dialogoUsuario = false
        },
        async getUsuarios() {
            this.loadingItemsUsuarios = true;
            try {
                let response = await axios.get('Usuarios/GetUsuarios/' + this.empresa.empresaBase)
                this.$store.state.listaUsuariosInternosStore = response.data
                console.log(response)
                this.loadingItemsUsuarios = false;

            } catch (error) {
                console.log(error)
                this.loadingItemsUsuarios = false;

            }
        },

        editarUsuario(data) {
            console.log(data)
            this.$store.state.usuarioInternosStore = { ...data }
            this.dialogoUsuario = true
        },
        async eliminarUsuario() {
            this.loading = true;
            this.loadingMensaje = 'Procesando soliciud, espere...'
            try {
                console.log(this.empresa)
                this.editedUsuario.usuarioModificador = this.empresa.nombre
                let response = await axios.put('Usuarios/PutUsuarioEstatus/' + this.empresa.empresaBase, this.editedUsuario)
                this.itemUsuarios.splice(this.editedIndexUsuario, 1)
                this.deleteProductDialog = false;
                this.loading = false;
                this.$toast.add({ severity: 'success', detail: 'Usuario eliminado con éxito.', life: 3000 });

            } catch (error) {
                console.log(error)
                this.$toast.add({ severity: 'error', detail: 'Error al eliminar, intente nuevamente.', life: 3000 });
                this.loading = false;
            }
        },
        confirmDeleteProduct(data) {
            this.editedIndexUsuario = this.itemUsuarios.indexOf(data)
            this.editedUsuario = { ...data };
            this.deleteProductDialog = true;
        },
    },
    components: { Usuarios }
}
</script>